/**
 * @desc 部门树
 */
import { DeptEntity, DeptTreeQuery } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryDeptTreeParameter = DeptTreeQuery

const method = 'GET'
const url = '/auth/dept/tree'

export const queryDeptTreeApi = (
  params?: QueryDeptTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<DeptEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryDeptTreeApi.method = method
queryDeptTreeApi.url = url
